<template>
    <div class="Mcp-SimulatorSteps">
        <nav class="nav-steps">
            <ul class="nav-steps__container">
                
                <!-- Current steps decoration -->
                <li class="current-state-step"
                    :style="{
                        'width': `${currentStepStyles.width}px`,
                        'height': `${currentStepStyles.height}px`,
                        'transform': `translateX(${currentStepStyles.left}px)`,
                    }"
                ></li>

                <!-- Simulator Steps -->
                <li 
                    v-for="(step, index) in simulatorSteps" :key="index"
                    class="nav-steps__step"
                    :class="{ 
                        current: currentStep === step.name,
                        validated: validatedSteps.includes(step.name)
                    }"
                    :data-index="index + 1"
                    :data-step="step.name"
                    :ref="`step_${step.name}`"
                    @click="navigateToStep"
                >
                    {{step.label}}
                </li>
                
            </ul>
        </nav>
    </div>
</template>

<script>
import resizeMixin from '@/mixins/events/resizeMixin.js'
import { mapActions, mapGetters } from "vuex";

export default {
    name: "TabSteps",

    mixins: [ resizeMixin ],

    computed: {
        ...mapGetters({ 
            simulatorSteps: "getSimulatorSteps",
            currentStep: "getCurrentStep",
            validatedSteps: "getValidatedSteps"
        }),
    },

    data() {
        return {
            currentStepStyles: {
                width: '',
                height: '',
                left: ''
            }
        };
    },

    methods: {
        //Style for current step slelector
        handleCurrentTabStyles() {
            if(this.$refs[`step_${this.currentStep}`]){
                const currentRef = this.$refs[`step_${this.currentStep}`][0]
                
                this.currentStepStyles = {
                                            width: currentRef.clientWidth,
                                            height: currentRef.clientHeight,
                                            left: currentRef.offsetLeft,
                                            translate: currentRef.offsetLeft,
                                        }
            }
        },

        // Navigate on step click 
        navigateToStep(e) {
            const step = e.target.getAttribute('data-step');
            const index = e.target.getAttribute('data-index');
            
            this.setCurrentStep(step)
            this.spliceValidateSteps(index-1)
        },

        /**
         * Map Actions
         */
        ...mapActions([
            "setCurrentStep",
            "spliceValidateSteps"
        ])
    },

    watch: {
        currentStep() {
            this.handleCurrentTabStyles()
        },
        
        screenWidth() {
            this.handleCurrentTabStyles()
        }
    },
    
    mounted() {
        this.handleCurrentTabStyles();
    },
    
    
}
</script>

<style lang="scss">
.Mcp-SimulatorSteps {
    padding: 0 28px;
    //margin-bottom: 75px;

    .nav-steps {
        &__container {
            display: flex;
            // mobil scroll horizontal
            overflow-x: auto;
            white-space: nowrap;
            padding-bottom: 15px;
        }
    
        &__step {
            pointer-events: none;
            padding: 13px 20px;
            color: $c-grey-light;
            font-size: 1.6rem;
            font-family: $font-family-normal;
            font-weight: $fw-robotoM;
    
            &::before {
                content: attr(data-index);
                display: inline-block;
                text-align: center;
                margin-right: 10px;
                width: 24px;
                height: 24px;
                border-radius: 50%;
                border: 1px solid $c-grey-light;
            }
    
            //Is current step
            &.current {
                position: relative;
                color: $color-white !important;
                background-color: $c-grey-blue;
                border-radius: 100px;

                &::before {
                    border-color: $color-white;
                }

                &::after {
                    content: "";
                    position: absolute;
                    left: 50%;
                    bottom: -4px;
                    width: 10px;
                    height: 10px;
                    transform: rotate(45deg);
                    background-color: $c-grey-blue;
                }

                // Current and already validate
                &.validated {
                    background-color: $c-mcp-green;

                    &::after {
                        background-color: $c-mcp-green;
                    }
                }
            }

            //Is validated
            &.validated {
                cursor: pointer;
                pointer-events: all;

                color: $c-mcp-green;

                &::before {
                    content:"\e91a";
                    font-family: 'icomoon' !important;
                    color: $color-white;
                    border-color: $c-mcp-green;
                    background-color: $c-mcp-green;
                }
            }
        }
    }

    .nav-steps .current-state-step {
        display: none;
        position: absolute;
        z-index: -1;
        background-color: $c-grey-bg2;
        border-radius: 100px;
        left: 0;
        transition: all .2s linear;
    }
}


.Mcp-SimulatorSteps {

    // Tablet 640px
    @include breakpoint(md) {
        .nav-steps__container {
            justify-content: flex-end;

            .nav-steps .current-state-step {
                display: initial;
            }
        }
    }
}

</style>